<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>信息查询</el-breadcrumb-item>
      <el-breadcrumb-item>项目得分</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-select
            v-model="queryInfo.query.matchName"
            placeholder="请选择赛项"
            clearable
            @change="getStandardList(1)"
            @clear="getStandardList(1)"
          >
            <el-option
              v-for="item in matchNameoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="queryInfo.query.trackName"
            placeholder="请选择赛道"
            clearable
          >
            <el-option
              v-for="item in trackNameoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              @change="getStandardList(1)"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="queryInfo.query.trackName"
            placeholder="请选择分组"
            clearable
          >
            <el-option
              v-for="item in groupOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              @change="getStandardList(1)"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input
            placeholder="请输入项目名称"
            v-model="queryInfo.query.StudentName"
            clearable
            @clear="getLeaveList(1)"
          >
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="getStandardList(1)"
            >搜索</el-button
          >
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="event_name" label="项目得分">
        </el-table-column>
        <el-table-column prop="event_name" label="项目名称">
        </el-table-column>
        <el-table-column prop="reg_begins" label="项目编号"> </el-table-column>
        <el-table-column prop="reg_end" label="赛道"> </el-table-column>
        <el-table-column prop="reg_end" label="负责人姓名"> </el-table-column>
        <el-table-column prop="reg_end" label="性别"> </el-table-column>
        <el-table-column prop="reg_end" label="手机号"> </el-table-column>
         <el-table-column prop="reg_end" label="所属学校"> </el-table-column>
        <el-table-column prop="reg_end" label="学校院系"> </el-table-column>
        <el-table-column prop="reg_end" label="专业领域"> </el-table-column>
        <el-table-column prop="reg_end" label="推荐人"> </el-table-column>
        <el-table-column prop="reg_end" label="指导老师"> </el-table-column>
        <el-table-column prop="reg_end" label="项目资料"> </el-table-column>
        <el-table-column prop="scoring_start" label="提交日期">
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        query: {
          // 赛项名称
          matchName: '',
          // 赛道名称
          trackName: ''
        },
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 1
      },
      pagedata: [],
      total: 0,
      // 赛事名称下拉选项
      matchNameoptions: [
        {
          value: '1',
          label: '赛事1'
        },
        {
          value: '2',
          label: '赛事2'
        }
      ],
      // 赛道下拉选项
      trackNameoptions: [
        {
          value: '1',
          label: '赛道1'
        },
        {
          value: '2',
          label: '赛道2'
        }
      ],
      // 专业领域下拉选项
      fieldOptions: [
        {
          value: '1',
          label: '张三'
        },
        {
          value: '2',
          label: '李四'
        }
      ]
    }
  },
  created() {
    //   默认获取列表
    this.getStandardList(1)
  },
  methods: {
    //   获取赛道列表
    async getStandardList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get('/api/create', this.queryInfo)
      if (res.meta.status !== 200) return console.log(res.Msg)
      this.pagedata = res.data.pagedata
      this.total = res.data.pagedata.length
      console.log(this.queryInfo)
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getStandardList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.getStandardList(newPage)
    }
  }
}
</script>
<style lang="less" scoped>
.el-col {
  width: 14% !important;
}
</style>
